import { Component } from 'react';
import { connect } from 'react-redux';
import { DropTarget } from 'react-dnd';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
// @ts-expect-error not typed yet
import { addModuleToLayoutSectionFromInpageSidebar } from 'InpageEditorUI/eventsAsActions/moduleEventsAsActions';
import { droppedOnLayoutSection, mouseCoordsAtDropUpdated
// @ts-expect-error not typed yet
} from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { dragTypes, dropTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { TOP, BEFORE, AFTER } from 'layout-dnd-utils/js/constants';
// @ts-expect-error not typed yet
import { convertClientOffsetToPageCoordinates } from 'layout-dnd-utils/scrollHelpers';
import { getCurrentDropTarget, getTargetedLayoutSectionId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import { DropZone } from 'foundations-components/transitional/components/DropZone';
import { Text } from 'foundations-components/components/Text';
import { addCustomSectionToDndAreaFromInpageSidebar, addCustomLayoutToDndAreaFromInpageSidebar, addEmbedToDndAreaFromInpageSidebar
// @ts-expect-error not typed yet
} from 'InpageEditorUI/eventsAsActions/sectionsEventsAsActions';
// @ts-expect-error not typed yet
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error not typed yet
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
import SectionsLibraryLayoutSectionEmptyState from 'InpageEditorUI/components/SectionsLibraryLayoutSectionEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const GROWTH_THEME_PATH = '@hubspot/growth';
const ELEVATE_THEME_PATH = '@hubspot/elevate';
const LOGGABLE_SECTION_LABEL_THEME_PATHS = [GROWTH_THEME_PATH, ELEVATE_THEME_PATH];
const getTargetForInsertedSection = dropTarget =>
// @ts-expect-error todo: The top level row drop target technically has the hover position as well
dropTarget.topOrBottomHovered === TOP ? BEFORE : AFTER;

// External props for consumers

// Infer the redux props from the connector

// Internal props are a combination of own props and redux props

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    mouseCoordsAtDropUpdated
  };
};
const dropTargetSpec = {
  drop(props, monitor) {
    // If we already dropped, don't rerun this handler
    if (monitor.didDrop()) {
      return;
    }
    const mouseCoordinates = convertClientOffsetToPageCoordinates(monitor.getClientOffset());
    props.mouseCoordsAtDropUpdated(mouseCoordinates);
    const {
      dispatchActionToEventBus,
      dropTarget,
      layoutSectionId
    } = props;
    const dragItem = monitor.getItem();
    const {
      contentType,
      dragId,
      isRow,
      originLayoutSectionId,
      widgetCid,
      customSectionId,
      customLayoutKey,
      sectionTree,
      isEmbed,
      sectionName,
      sectionLabel
    } = dragItem;
    const droppedInfo = {
      contentType,
      originLayoutSectionId
    };
    if (isRow) {
      droppedInfo.existingRowId = dragId;
    } else {
      droppedInfo.existingColumnId = dragId;
    }
    const dropAction = droppedOnLayoutSection(droppedInfo, dropTarget, layoutSectionId);
    if (dropAction && dropTarget) {
      // If we have a widgetCid, it means the drag item is a new module from the Inpage Sidebar.
      if (widgetCid) {
        // We have to use dispatchActionToEventBus here because WidgetAddController is
        // handling the reception of this event, and not a Redux action in the parent.
        dispatchActionToEventBus(addModuleToLayoutSectionFromInpageSidebar(Object.assign({
          widgetCid
        }, dropAction)));
      } else if (isEmbed) {
        const targetBeforeOrAfter = getTargetForInsertedSection(dropTarget);
        dispatchActionToEventBus(addEmbedToDndAreaFromInpageSidebar(Object.assign({
          embedId: customSectionId,
          targetBeforeOrAfter,
          embedName: sectionName
        }, dropAction)));
        dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_EMBED_FROM_SIDEBAR, {}));
      } else if (customSectionId) {
        const targetBeforeOrAfter = getTargetForInsertedSection(dropTarget);
        dispatchActionToEventBus(addCustomSectionToDndAreaFromInpageSidebar(Object.assign({
          customSectionId,
          sectionTree,
          targetBeforeOrAfter,
          isEmptyLayoutSection: dropTarget.id === layoutSectionId && dropTarget.type === dropTypes.INSERT_INTO_EMPTY_COLUMN
        }, dropAction)));
        if (dragItem.isMarketerSection) {
          dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_SAVED_SECTION_FROM_SIDEBAR, {}));
        } else {
          const payload = dragItem.themePath && LOGGABLE_SECTION_LABEL_THEME_PATHS.includes(dragItem.themePath) ? {
            label: sectionLabel,
            themePath: dragItem.themePath
          } : {};
          dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_DEVELOPER_SECTION_FROM_SIDEBAR, payload));
        }
      } else if (customLayoutKey) {
        const targetBeforeOrAfter = getTargetForInsertedSection(dropTarget);
        dispatchActionToEventBus(addCustomLayoutToDndAreaFromInpageSidebar(Object.assign({
          customLayoutKey,
          targetBeforeOrAfter
        }, dropAction)));
        dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_LAYOUT_FROM_SIDEBAR, {}));
      } else {
        props.dispatch(dropAction);
      }
    }
  }
};
const dropCollect = (dropConnect, monitor) => {
  return {
    connectDropTarget: dropConnect.dropTarget(),
    isOver: monitor.isOver(),
    dragItem: monitor.getItem()
  };
};
const mapStateToProps = state => {
  return {
    dropTarget: getCurrentDropTarget(state),
    layoutSectionId: getTargetedLayoutSectionId(state)
  };
};
class LayoutSectionDropZoneContainer extends Component {
  isHovered() {
    const {
      dropTarget,
      parentId
    } = this.props;
    return !!dropTarget && dropTarget.id === parentId;
  }
  render() {
    const {
      connectDropTarget,
      hasSectionsLibraryAccess,
      parentId
    } = this.props;
    return connectDropTarget(
    /*#__PURE__*/
    // The namespace class is required for styled-components
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: NAMESPACE_CLASS,
      children: /*#__PURE__*/_jsx(DropZone, {
        size: "small",
        use: this.isHovered() ? 'hover' : hasSectionsLibraryAccess ? 'selected' : 'default',
        margin: "0",
        "data-test-id": "layout-section-drop-zone",
        children: hasSectionsLibraryAccess ? /*#__PURE__*/_jsx(SectionsLibraryLayoutSectionEmptyState, {
          layoutSectionId: parentId
        }) : /*#__PURE__*/_jsx(Text, {
          color: "icon-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.layoutSection.dropZone"
          })
        })
      })
    }));
  }
}
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(DropTarget([DRAG_TYPES.ADD_MODULE, dragTypes.EXISTING_ITEM, DRAG_TYPES.CUSTOM_SECTION], dropTargetSpec, dropCollect)(LayoutSectionDropZoneContainer));